import React, { createContext, useContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { fetchCalendars } from '../../calendars'
import { useAccount } from '../'
import { Agora } from '../../livestream'
import { useHistory } from 'react-router-dom'

const ResolverContext = createContext({})

const ResolverProvider = ({ children }) => {
    const history = useHistory()

    const dispatch = useDispatch()
    const { account } = useAccount()
    const calendars = useSelector(state => state.calendars.items)
    const [ personalCalendar, setPersonalCalendar ] = useState({})

    useEffect(() => {
        const unlisten = history.listen(location => {
            Agora.checkShouldLeave(location)
        })

        return () => {
            unlisten()
        }
    }, [history])

    useEffect(() => {
        if (!account) {
            return
        }
        dispatch(fetchCalendars())
    }, [ account, dispatch ])

    useEffect(() => {
        calendars.length &&
            setPersonalCalendar(calendars.find(cal => cal.isPersonal))
    }, [ calendars, personalCalendar ])

    const fetchMyCalendars = () => dispatch(fetchCalendars()) // TODO this should be with delta updates.
    const findCalendar = calendarId => calendars.find(item => item.calendarId === calendarId)

    return (
        <ResolverContext.Provider
            value={ {
                calendars, personalCalendar,
                findCalendar, fetchMyCalendars
            } }>
            { children }
        </ResolverContext.Provider>
    )
}

ResolverProvider.propTypes = {
    children: PropTypes.object
}

export const useResolver = () => useContext(ResolverContext)
export default ResolverProvider